/* eslint-disable no-sequences */
/* eslint-disable prefer-const */
const styleCurrentPositionMarker = () => {
  // Styling current position marker
  let boxShadowDiv;
  let tipDiv;
  boxShadowDiv = document.body.getElementsByClassName(
    'leaflet-popup-content-wrapper',
  );
  tipDiv = document.body.getElementsByClassName('leaflet-popup-tip');
  for (let i = 0; i < boxShadowDiv.length, i < tipDiv.length; i++) {
    boxShadowDiv[i].setAttribute(
      'style',
      'box-shadow: none; height: 30px; background-color: #26d07c; color: white; align-items: center; display: flex; justify-content: center;',
    );
    tipDiv[i].setAttribute(
      'style',
      'box-shadow: none; background-color: #26d07c;',
    );
    tipDiv[i].style['box-shadow'] = 'none';
    boxShadowDiv[i].childNodes[0].setAttribute('style', 'margin: 0px;');
  }
};
export default styleCurrentPositionMarker;
